import { React, useState, useEffect } from "react";
import {
  ADANI_COLOR_PALATE,
  ACC_COLOR_PALATE,
  AMBUJA_COLOR_PALATE,
  DARPAN_COLOR_PALATE,
} from "../constants/common";

const BigBox = ({
  header = "",
  children,
  selectedOption,
  options = [],
  onChange,
  centerContent = false, 
}) => {
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;
  const [selectedIndex, setSelectedIndex] = useState(options[0]);

  const [palate, setPalate] = useState([]);
  async function getBrandThemePalate() {
    let palate = ADANI_COLOR_PALATE;
    const id = brandId;
    switch (id + "") {
      case "1":
        palate = ACC_COLOR_PALATE;
        break;
      case "2":
        palate = AMBUJA_COLOR_PALATE;
        break;
      case "Darpan":
        palate = DARPAN_COLOR_PALATE;
        break;
      default:
        palate = ADANI_COLOR_PALATE;
    }
    setPalate(palate);
  }

  useEffect(() => {
    setSelectedIndex(options[0]);
    getBrandThemePalate();
  }, [brandId]);

  return (
    <div className="big-box-container">
      {header && (
        <div
          className="big-box-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // padding: "0 16px",
            flexWrap: "wrap",
          }}
        >
          <span>{header}</span>
          {options?.length > 0 && (
            <div style={{ borderRadius: "10px", overflow: "hidden" }}>
              {options.map((option) => (
                <button
                  key={option}
                  style={{
                    borderRadius: "0px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                  }}
                  className={`toggle-btn ${
                    selectedOption === option ? "active" : ""
                  }`}
                  onClick={() => onChange(option)}
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <div
        className="big-box-grid"
        style={
          centerContent
            ? {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "16px",
                textAlign: "center",
              }
            : {
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "16px",
                padding: "8px",
              }
        }
      >
        {children}
      </div>
    </div>
  );
};

export default BigBox;

